import React from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowUpRight,
  faQuestionCircle,
} from "@fortawesome/pro-regular-svg-icons";
import { capitalize } from "lodash";
import { twJoin } from "tailwind-merge";

import { Pill } from "src/base-components/Pill";
import { EntityTabIds } from "src/entities/entityView/useEntityTabRefresh";
import { Environment } from "src/hooks/useEnvironment";
import { useWorkspaceContext } from "src/router/routerContextHooks";
import { getBaseUrl, getUrlToEntityDetailPage } from "src/router/urls";

type LinkedEntityPillProps = {
  name: string;
  id: string;
  schemaId: string;
  entityIcon?: IconProp;
  fullWidth?: boolean;
  environment?: Environment;
};

export const LinkedEntityPill: React.FC<LinkedEntityPillProps> = ({
  name,
  id,
  schemaId,
  entityIcon = faQuestionCircle,
  fullWidth = true,
  environment,
}) => {
  const { orgId, workspace } = useWorkspaceContext();
  const url =
    getBaseUrl() +
    getUrlToEntityDetailPage(
      orgId,
      workspace.id,
      schemaId,
      id,
      EntityTabIds.Decisions,
      environment,
    );

  return (
    <a
      className={twJoin(fullWidth ? "w-full" : "w-fit")}
      href={url}
      rel="noreferrer"
      target="_blank"
    >
      <Pill fullWidth={fullWidth} size="sm" variant="gray">
        <Pill.Icon icon={entityIcon} />
        <Pill.Text>{capitalize(name)}</Pill.Text>
        <Pill.Icon icon={faArrowUpRight} />
      </Pill>
    </a>
  );
};
